var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{staticClass:"circle",class:{'ripple': _vm.ripple && _vm.infinite, 'dark':_vm.dark},attrs:{"size":_vm.size,"width":_vm.width,"color":_vm.color,"indeterminate":_vm.infinite}},[_c('v-avatar',_vm._b({attrs:{"size":_vm.logoSize}},'v-avatar',_vm.$attrs,false),[_c('BrandLogo',{attrs:{"branded":_vm.branded}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }